package com.crowpay

import com.crowpay.notifications.EventSubscription
import com.crowpay.notifications.EventType


val EventSubscription.Companion.REQUIRED get() = "REQUIRED"
val EventSubscription.Companion.CONTRACTOR_REQUIRED get() = "CONTRACTOR REQUIRED"
val EventSubscription.Companion.HOMEOWNER_REQUIRED get() = "HOMEOWNER REQUIRED"

const val FOR_HOMEOWNERS = "FOR HOMEOWNERS EXCLUSIVELY"
const val FOR_CONTRACTORS = "FOR CONTRACTORS EXCLUSIVELY"

object SharedEvents {
    sealed interface SharedEvent

    data class Event(
        val name: String,
        val tags: Set<String> = emptySet(),
        override val displayName: String = name,
        val description: String? = null
    ): HasDisplayName, SharedEvent {
        val type get() = EventType(name, tags)
    }

    data class WithReminders(
        val name: String,
        val tags: Set<String> = emptySet(),
        val reminderName: String = "Reminder: $name",
        val reminderTags: Set<String> = tags,
        val displayName: String = name,
        val reminderDisplayName: String = "$displayName Reminders",
        val description: String? = null,
        val reminderDescription: String? = null
    ): SharedEvent {
        val event get() = Event(name, tags, displayName, description)
        val reminders get() = Event(reminderName, reminderTags, reminderDisplayName, reminderDescription)

        fun addTags(vararg tags: String) = copy(tags = this.tags+tags, reminderTags = this.tags+tags)
    }

    val projectStatusUpdated = Event("Project Status Updated")
    val projectMessageSent = Event("Project Message Sent")
    val projectPublished = Event("Project Published", setOf(FOR_CONTRACTORS))
    val projectAccepted = Event("Project Accepted", setOf(FOR_CONTRACTORS))
    val canStartProject = WithReminders("Project Pending Start", setOf(FOR_CONTRACTORS, EventSubscription.CONTRACTOR_REQUIRED))


    val lineItemStatusUpdated = Event("Work Item Status Update")
    val newNoteActivity = Event("New Note Activity", setOf(FOR_HOMEOWNERS))
    val newTaskActivity = Event("New Task Activity", setOf(FOR_HOMEOWNERS))

    val homeownerConnectBankAccount = WithReminders("Homeowner Connect Bank Account", setOf(FOR_HOMEOWNERS), displayName = "Connect Bank Account")
    val contractorConnectBankAccount = WithReminders("Contractor Connect Bank Account", setOf(FOR_CONTRACTORS), displayName = "Connect Bank Account")

    val escrowDepositRequested = WithReminders("Escrow Deposit Requested", setOf(FOR_HOMEOWNERS, EventSubscription.HOMEOWNER_REQUIRED), reminderDisplayName = "Escrow Deposit Reminders")
    val escrowFundsReceived = Event("Escrow Funds Received", setOf(FOR_HOMEOWNERS))
    val escrowFullyFunded = Event("Escrow Fully Funded")

    val drawReady = WithReminders("Draw Ready", setOf(FOR_HOMEOWNERS, EventSubscription.HOMEOWNER_REQUIRED), reminderDisplayName = "Draw Review Reminders")
    val drawItemsApproved = Event("Draw Work Item(s) Approved", setOf(FOR_CONTRACTORS))
    val drawItemsWaited = Event("Draw Work Item(s) Waited", setOf(FOR_CONTRACTORS))
    val drawFullyApproved = Event("Draw Fully Approved", setOf(FOR_CONTRACTORS))

    val changeRequestPublished = WithReminders("Change Request Published", setOf(FOR_HOMEOWNERS, EventSubscription.HOMEOWNER_REQUIRED), displayName = "Change Review Ready")
    val pendingLineItemApproved = Event("Pending Line Item Approved", setOf(FOR_CONTRACTORS))
    val pendingLineItemRejected = Event("Pending Line Item Rejected", setOf(FOR_CONTRACTORS))
    val pendingItemChangeApproved = Event("Pending Item Change Approved", setOf(FOR_CONTRACTORS))
    val pendingItemChangeRejected = Event("Pending Item Change Rejected", setOf(FOR_CONTRACTORS))
    val changeFullyApproved = Event("ChangeRequest Fully Approved", setOf(FOR_CONTRACTORS), displayName = "Change Fully Approved")
    val changeFullyRejected = Event("ChangeRequest Fully Rejected", setOf(FOR_CONTRACTORS), displayName = "Change Fully Rejected")

    val lineItemSignOffRequested = WithReminders("Line Item Sign-Off Requested", setOf(FOR_HOMEOWNERS, EventSubscription.HOMEOWNER_REQUIRED), displayName = "Sign-Off Requested")
    val lineItemAutoCompleted = Event("Work Item Auto-Completed")
    val fundsReleasedPending = Event("Funds Released Pending", setOf(FOR_CONTRACTORS))
    val fundsReleasedConfirmed = Event("Funds Released Confirmed")

}